import { Settings } from 'ontime-types';

export const ontimePlaceholderSettings: Settings = {
  version: '4.0.0',
  serverPort: 4001,
  editorKey: null,
  operatorKey: null,
  timeFormat: '24',
  language: 'en',
};
